export default __webpack_public_path__ + "static/media/Efficiensee AI logo.c7b61a0f.svg";